import HelpfulTipsPickup from './HelpfulTipsPickup';

export default HelpfulTipsPickup;
